/**
 * Where the app is running inside Microsoft Teams, so an upload can be filed in the channel it came from
 * rather than in the team's shared library.
 *
 * This is a value store, not a fetcher. `App` already resolves the Teams context once at mount and is the only
 * writer; outside Teams that resolution never happens, so the store stays empty, callers send nothing, and the
 * server falls back to resolving the destination from the ticket's team. Absent is the normal case.
 *
 * It imports nothing on purpose: `platformService` reads it and is itself reachable from `App`, so any import
 * here would close a cycle.
 */
export interface TeamsChannelContext {
  teamsTeamId?: string;
  teamsChannelId?: string;
}

let current: TeamsChannelContext = {};

export const setTeamsChannelContext = (context: TeamsChannelContext) => {
  current = context;
};

export const getTeamsChannelContext = (): TeamsChannelContext => current;
